import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Constant } from '../../../constants/constant';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterLink, RouterModule, UrlSegment } from '@angular/router';
import { ConfigServiceService } from '../../services/config-service.service';
import { Meta, Title } from '@angular/platform-browser';
import { CommonService } from '../../services/common.service';
import { UrlService } from '../../services/url.service';
import { CategoryService } from '../../services/category.service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { DefaultLayoutDirective } from '../../flex-layout/custom-layout';
import { DefaultShowHideDirective } from '../../flex-layout/show-hide';
import { DefaultFlexDirective } from '../../flex-layout/flex';
import { DefaultLayoutGapDirective } from '../../flex-layout/custom-layout-gap';
import { DefaultLayoutAlignDirective } from '../../flex-layout/custom-layout-align';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { DefaultClassDirective } from '../../flex-layout/class';
import { DefaultStyleDirective } from '../../flex-layout/style';
import { CustomFlexLayoutModule } from '../../flex-layout/custom-flex-layout.module';
import { MatCard, MatCardModule } from '@angular/material/card';

@Component({
  selector: 'calsoft-breadcrumb',
  imports: [ DefaultShowHideDirective,
    DefaultLayoutDirective,
    DefaultFlexDirective,
    MatCard,
    RouterLink,
    DefaultLayoutGapDirective,
    DefaultLayoutAlignDirective,
    MatIcon,
    DefaultClassDirective,
    DefaultStyleDirective,
    CustomFlexLayoutModule,
    RouterModule,
    MatCardModule,
    MatIconModule],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent {

   @Output() valueChange = new EventEmitter();
    public serverPath2 = environment.commonImageApi + '/categoryBanner/';
    @Input() name: any;
    @Input() value: any;
    @Input() type: any = "'breadCrump'";
    previousUrl: Observable<string> | any;
    public pageTitle: string |any;
    public breadcrumbs: {
        name: string;
        url: string
    }[] = [];
    categoryDetails: any;
    currentUrl: string |any;
    navigated: any = false;
    url: boolean =false;
    visible: boolean=false;
    displayDescripion: boolean = false;
    displayCategoryImage: boolean = false;
    path: string |any;
    firstFormGroup: any;
    breadcrumbType:any;
    imgHeight: any;
    imgMobHeight:any;



    constructor(
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public title: Title,
        public categoryService: CategoryService,
        private urlService: UrlService,
        private commonService: CommonService,
        public meta: Meta,
        private configService :ConfigServiceService,
    ) {

        this.breadcrumbType = 1;
    }

    ngOnInit() {
       this.previousUrl = this.urlService.previousUrl$;
        this.getConfigData();
        if (!this.router.url.includes("pr?sid")) {
            this.visible = true;
        } else {
            this.visible = false;
        }

        if (this.router.url.includes("/Brochure/") || this.router.url.includes("/CRM_videos/")) {
            this.visible = false;
        } else {
            this.visible = true;
        }

        if (!this.navigated) {
            this.parseRoute(this.activatedRoute.snapshot);
        }
    }

    private parseRoute(node: ActivatedRouteSnapshot) {
        let type = "any";
        let value = this.activatedRoute.snapshot.queryParamMap.get('sid');
        this.urlService.previousUrl$.subscribe((previousUrl: string) => {            
            if (this.router.url.includes("/" + "product") 
            && (previousUrl == null || previousUrl.includes("/" + "search"))) {
                type = "product"
            }  else if (this.router.url.includes("/" + "booking-detail")) {
                type = "product"
                node.data['breadcrumb']="Product"
            }
            else if (previousUrl == null) {
                type = "any";
            }
            else if (!previousUrl.includes("/pr") && this.router.url.includes("/" + "product")) {
                type = "product"
            }else if (this.router.url.includes("/" + "product") && previousUrl.includes("/pr")) {

                this.urlService.breadCrumpUrl$.subscribe((categoryName: string) => {
                    value = categoryName;

                });
            }
        });

        if (node.data['breadcrumb']) {
            if (node.url.length) {
                let urlSegments: UrlSegment[] = [];
                node.pathFromRoot.forEach((routerState:any) => {
                    urlSegments = urlSegments.concat(routerState.url);
                });
                let url = urlSegments.map(urlSegment => {
                    return urlSegment.path;
                }).join('/');
                if (node.params['name'] == 'Recently Added') {
                    this.breadcrumbs.push({
                        name: "Recently Added Products",
                        url: 'sa'
                    })
                }

                else if (node.params['name'] && !this.navigated) {
                    this.breadcrumbs.splice(0, 1);

                    if (this.router.url.includes("/product?pid")) {
                        type = 'product';
                        value = this.activatedRoute.snapshot.queryParamMap.get('pid');
                    }
                   else if (this.router.url.includes("/booking-detail/")) {
                        type = 'product';
                        value = this.activatedRoute.snapshot.queryParamMap.get('pid');
                    }
                    else if (this.router.url.includes("/course/")) {
                        type = 'product';
                        value = this.activatedRoute.snapshot.queryParamMap.get('pid');
                    }

                    else if (type == 'product' || value == null) {
                        type = 'product';
                        value = this.value

                        // if (value.includes("SLS")) {

                        //     value = value.replace(/SLS/g, '/');
                        // }
                        // value = value.replace(/_/g, ' ');
                        // //   value=value.replace(/&/g,'”');
                        // //   value=value.replace(/Ro/g,'®');
                        // value = value.replace(/BRS/g, '(');
                        // value = value.replace(/BREl3jk875/g, ')');

                        // value = value.replace(/"/g, "Por21Ld245");
                        // value = this.ecryptServiceService.encrypt(value);

                        //
                        // value = value.replace(/\//g, "SLS");
                        // value = value.replace(/\%/g, 'xMl3Jk');

                    }

                    if (this.router.url.includes("/type")) {
                        value = this.value
                        type = "product";
                    }
                    if (this.router.url.includes("/product/")) {
                        value = this.activatedRoute.snapshot.params['pid'];
                        type = "product";
                    }

                    if (this.router.url.includes("pr?sid")) {
                        value = this.activatedRoute.snapshot.queryParams['sid']
                        type = "any";

                    }

                    if (this.router.url.includes("/booking-detail/")) {
                        value = this.activatedRoute.snapshot.params['pid'];
                        type = "product";
                    }

                    this.categoryService.categoryById(value, type).subscribe(
                        (res:any) => {
                            this.categoryDetails = res;

                            if (this.type == 'product') {
                                this.displayDescripion = this.categoryDetails['displayDescription'] == 1 ? true : false;
                                this.valueChange.emit(this.categoryDetails['productListType'] == 1 ? 'grid' : 'list')

                                if (this.categoryDetails.isCustomValue != null) {

                                    if (this.categoryDetails.isCustomValue.customDesign != null && this.categoryDetails.isCustomValue.customDesign != null) {

                                        if (this.categoryDetails.isCustomValue.landingPage == 1) {
                                            this.displayCategoryImage = true;
                                            this.path = this.serverPath2 + this.categoryDetails.isCustomValue.customDesign;
                                        }


                                    } else {

                                        this.displayCategoryImage = false;
                                    }

                                }
                            }
                            let a = this.categoryDetails['breadCrumpPath'].split(",")
                            let b = this.categoryDetails['path'].split(",")
                            if (this.router.url.includes("/" + "product")) {

                                // node.params.name=this.name

                                a.push(this.name)
                            }
                            if (this.router.url.includes("/booking-detail/")) {

                    

                                a.push(this.name)
                            }
                            for (var i = 0; i < a.length; i++) {

                                if (a.length - 1 == i) {
                                    a[i] = a[i].replace(/_/g, ' ');
                                    a[i] = a[i].replace(/BRSl2jk785/g, '(');
                                    a[i] = a[i].replace(/BREl3jk875/g, ')');
                                    a[i] = a[i].replace("Por21Ld245", '"');
                                    a[i] = a[i].replace(/xMl3Jk/g, '%');
                                    a[i] = a[i].replace(/plusAdd/g, '+');
                                }

                                this.breadcrumbs.push({
                                    name: a[i],
                                    url: b[i] + '/pr'
                                })

                                if (node.params['name'].length < 0) {
                                    let name = node.params['name']


                                    //name= name.replace(/_/g,' ');



                                    this.breadcrumbs.push({
                                        name: name,
                                        url: "sa"
                                    })
                                }
                            }

                            if (this.router.url.includes("/product/")) {
                                let value = this.breadcrumbs[this.breadcrumbs.length - 1].name

                                this.title.setTitle('Buy ' + value + " Online at Best Price,Order Now");

                                this.meta.addTags([
                                    { name: 'author', content: Constant.siteName },
                                    { name: 'keywords', content: value },
                                ]);


                            }

                            if (this.router.url.includes("/booking-detail/")) {
                            }

                        }, () => {

                        }
                    )

                }
                else if (node.data['breadcrumb'] == 'My Order') {
                    this.breadcrumbs.push({
                        name: 'Account Settings',
                        url: '/account/information'
                    })
                    this.breadcrumbs.push({
                        name: "My Orders",
                        url: '/orders'
                    })
                    this.breadcrumbs.push({
                        name: node.params['entityId'],
                        url: "sa"
                    })
                }
                else if (node.data['breadcrumb'] == 'Checkout') {
                    this.breadcrumbs = [];
                    this.breadcrumbs.push({
                        name: 'CHECKOUT',
                        url: '/checkout'
                    })

                }
                else if (node.data['breadcrumb'] == 'My Orders') {
                    this.breadcrumbs.push({
                        name: 'Account Settings',
                        url: '/account/information'
                    })
                    this.breadcrumbs.push({
                        name: "My Orders",
                        url: 'sa'
                    })
                }

                else if (node.data['breadcrumb'] == 'pages') {
                    this.activatedRoute.snapshot.params['pageId'];
                    const path = this.router.url; // Get the path segment
                    const splitPath = path.split('/'); // Split the path by '/'
                    let value = splitPath[splitPath.length - 1]; // Get the last segment
                    value = value.replace(/%20/g, ' ');

                    this.breadcrumbs.push({
                        name: value,
                        url: '/'
                    })

                }
                else if (this.router.url.includes('/blog/')) {
                    this.breadcrumbs = [];
                    this.breadcrumbs.push({
                        name: 'Blog',
                        url: '/blog'
                    });
                
                    // const inputString = this.router.url;
                    // const parts = inputString.split('/');
                    // const result = parts[2];
                    // const decodedResult = decodeURIComponent(result); // Decode the URL part to get the original name
                    // const encodedResult = decodedResult.replace(/\+/g, ' '); // Replace the "+" with spaces
                
                    let value=this.activatedRoute.snapshot.queryParams['title'];
                    this.breadcrumbs.push({
                        name: value, // Use the properly decoded name in the breadcrumb
                        url: '/blog/' + value // Use the original URL part in the breadcrumb URL
                    });
                }
                

                else if (!this.navigated) {

                    this.breadcrumbs.push({
                        name: node.data['breadcrumb'],
                        url: '/' + url
                    })
                }
            }
        }
        if (node.firstChild) {
            this.parseRoute(node.firstChild);
        }
        this.navigated = true;
    }


    navigate(breadcrumb :any) {

        if (breadcrumb.url.includes("/pr")) {

            let path = breadcrumb.url.split("/")[0]

            this.commonService.goToCategory(breadcrumb.name, parseInt(path))
        } else {
            this.router.navigate([breadcrumb.url]);
        }
    }

    getConfigData() {
        this.configService.getConfigData()
          .subscribe(
            (data:any) => {
              this.breadcrumbType = data['breadcrumbType'];

              this.imgHeight = data['bannerHeightInCategoryPage'];
              this.imgMobHeight = data['bannerMobileHeightInCategoryPage'];              


             // console.log(this.breadcrumbType);
              
              }, () => {
    
              });
    }



}
